<template>
  <div class="story-text-container">
    <p class="story-text-style">
      My family lived in a small house by the riverbend in the outskirts of the
      town of Anixon, my dad was a blacksmith and my mother a professional
      fairy. They were two completely different people, but complimented each
      other in a way and formed their own little traditions. One of them was our
      dinners together. It was my favourite time of day because that’s when I
      always felt a sense of togetherness despite our differences. Though that
      was slightly changing recently – there was a sense of uneasiness, tension
      that I couldn’t really understand, but I had a feeling that something was
      wrong.
      <br>
      <br>Then came the dinner I still remember clear as day. My father was
      out until late, looked grimmer than usual and never told anyone where he
      was. My mother seemed like she had something to say but kept the words
      trapped on the tip of her tongue. I remember I was staring into my plate
      thinking, when my dad finally said the words, “We should get out of here
      Anabelle, we can’t risk it, we need to get the kids away from here”. My
      mother turned around, her voice melodic as always, but slightly tensed,
      “It would be okay Akio, the Gremlins can never come here. I told you not
      to worry yourself for no reason”. “The whispers though, the rumours of the
      war in the west… you’ve heard them as well as I did”. “Whatever they say,
      I trust the army to protect us” my mother replied as my father frowned at
      her. “I wouldn’t be so trusting. Even an army is fallible and we can’t
      ever be sure that groups of Gremlins won’t infiltrate and raid Anixon.”
      “Jeez Akio, if you are done here I’m going to attend to the plants” and
      she let her delicate wings fly her out into the garden. “Her naiveness is
      going to get us all killed!” my dad pushed the table and stormed out in
      the direction of his workspace.
    </p>
    <section class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateTo('father')">Follow My Father</button>
      <button class="story-btn-style" @click="navigateTo('mother')">Follow My Mother</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-One",
  data() {
    return {
      personalityTypes: [
        ["Courageous", ""],
        ["CombatSkill", ""],
        ["Uno-Clan", "Dos-Clan"],
        ["Leadership", ""]
      ]
    };
  },
  methods: {
    navigateTo(choice) {
      this.$store.dispatch("updateChoice", choice);
      this.$store.commit("setModalDisplay", {
        display: true,
        isGranted: true,
        url: "/story/two"
      });
    }
  },
  created() {
    for (let i = 0; i < this.personalityTypes.length; i++) {
      const randomPersonality = this.personalityTypes[i][
        Math.floor(Math.random() * 20) % 2
      ];
      this.$store.dispatch("updatePersonality", randomPersonality);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/Scheme.scss";
</style>
